import { Modal, TableCustom } from "../../common"
import { getDateToString, getFormatNumber, getNumeroRecibo_ObjectToIdentificador } from "../../../utils/convert"
import { ServerRequest } from "../../../utils/apiweb"
import { ALERT_TYPE, REQUEST_METHOD, ShowToastMessage } from '@laramie/ui';
import { APIS } from "../../../config/apis"
import { onRequestError, onRequestNoSuccess } from "../../../utils/requests"
import { useEffect, useState } from "react"
import ReciboPublicacionModal from "../ReciboPublicacionModal"
import { useManagedContext, useLista } from "../../hooks"
const PublicacionesGridModal = ({ idPublicacionLote, onCancel }) => {
    
    const { setIsLoading, showMessageModal } = useManagedContext()

    const [publicaciones, setPublicaciones] = useState([])
    const [idReciboPublicacion, setIdReciboPublicacion] = useState(null)

    const [getLista, ] = useLista({
        listas: ['TipoTributo'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'TipoTributo',
          timeout: 0
        }
    });

    const getDescTipoTributo = (codigoTipoTributo) => {
        const listaTipoTributo = getLista('TipoTributo');
        const tipoTributo = listaTipoTributo.find(item => item.codigo === codigoTipoTributo);
        return tipoTributo ? tipoTributo.nombre : "";
    }

    useEffect(() => {
        if (idPublicacionLote > 0) {
            SearchPublicaciones(idPublicacionLote)
        }
    }, [])

    const SearchPublicaciones = (idPublicacionLote) => {
        setIsLoading(true)

        const paramsUrl = `/detalle/${idPublicacionLote}`

        ServerRequest(
            REQUEST_METHOD.GET,
            null,
            true,
            APIS.URLS.RECIBO_PUBLICACION_LOTE,
            paramsUrl,
            null,
            res => res.json().then(data => {
                setPublicaciones(data)
                setIsLoading(false)
            }),
            res => {
                onRequestNoSuccess(res)
                setIsLoading(false)
            },
            err => {
                onRequestError(err)
                setIsLoading(false)
            },
        )
    }

    const avmr = {
        onView: (item) => {
            if (item.id) {
                setIdReciboPublicacion(item.id)
            }
            else {
                ShowToastMessage(ALERT_TYPE.ALERT_WARNING, 'No existe un VEP de publicación asociado.');
            }
        },
    }

    return (
        <Modal
            onEscape={onCancel}
            allowFullscreen={true}
            size="xl"
            title="VEPs"
            body={(
                <>
                <TableCustom
                    className={'TableCustomBase m-top-10'}
                    data={publicaciones}
                    avmr={avmr}
                    columns={[
                        { Header: 'N° cuenta', accessor: 'numeroCuenta', width: '14%' },
                        { Header: 'Tipo de tributo', Cell: (props) => { return getDescTipoTributo(props.value); }, accessor: 'codigoTipoTributo', width: '10%' },
                        { Header: 'N° VEP', accessor: 'numeroRecibo', width: '12%', Cell: ({ row }) => (row.original.numeroRecibo > 0) ?  getNumeroRecibo_ObjectToIdentificador(row.original) : row.original.codigoBarras },
                        { Header: 'Periodo', accessor: 'periodo', width: '8%', alignCell: 'right' },
                        { Header: 'Cuota', accessor: 'cuota', width: '6%', alignCell: 'right' },
                        { Header: 'Importe 1', accessor: 'importeVencimiento1', Cell: (data) => getFormatNumber(data.value, 2), width: '10%', alignCell: 'right' },
                        { Header: 'Importe 2', accessor: 'importeVencimiento2', Cell: (data) => getFormatNumber(data.value, 2), width: '10%', alignCell: 'right' },
                        { Header: '1° Vto.', accessor: 'fechaVencimiento1', Cell: (data) => getDateToString(data.value), width: '10%'},
                        { Header: '2° Vto.', accessor: 'fechaVencimiento2', Cell: (data) => getDateToString(data.value), width: '10%'},
                        { Header: 'Código de barras', accessor: 'codigoBarras', width: '10%'},                   
               
                    ]}
                    showDownloadCSV={true}
                />

                {idReciboPublicacion && (
                    <ReciboPublicacionModal
                        id={idReciboPublicacion}
                        onCancel={() => setIdReciboPublicacion(null)}
                    />
                )}

                </>
            )}
            footer={(
                <div className="width-100p disp-b">
                    <button className="btn back-button m-left-5" data-dismiss="modal" onClick={onCancel}>Volver</button>
                </div>
            )}
        />
    )
}

export default PublicacionesGridModal
